// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash/fp';

// Utils
import {
    getNotificationRemindersAsArray,
    getNotificationReminderText,
} from '../../../../../../../common/notifications/notificationModelUtils';
import {
    getIsDueSoon,
    getNotificationReminderDueDateText,
    getReminderDueDateClass,
} from '../../../../../../../common/notifications/notificationReminderUtils';
import { chooseSingular } from '../../../../../../../common/utils/stringUtil';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import StandardNotificationBoardTitle from './StandardNotificationBoardTitle';
import NotificationFigureReminder from './NotificationFigureReminder';

// Styles
import './NotificationEntryTaskReminder.scss';

const ReminderEntry = ({ reminder, notification }) => {
    const dueDateText = getNotificationReminderDueDateText(reminder);
    const dueDateClass = getReminderDueDateClass({ reminder, notification });

    const text = getNotificationReminderText(reminder);

    return (
        <li className="ReminderEntry">
            <span className={classNames('due-date', dueDateClass)}>{dueDateText}</span>
            <span className="text">{text}</span>
        </li>
    );
};

ReminderEntry.propTypes = {
    notification: PropTypes.object,
    reminder: PropTypes.object,
};

const ReminderEntries = ({ reminders, notification }) => {
    if (isEmpty(reminders)) return null;

    return (
        <ul className="ReminderEntries">
            {reminders.map((reminder, index) => (
                <ReminderEntry key={index} reminder={reminder} notification={notification} />
            ))}
        </ul>
    );
};

ReminderEntries.propTypes = {
    notification: PropTypes.object,
    reminders: PropTypes.array,
};

const NotificationEntryTaskReminder = (props) => {
    const { notification } = props;

    const reminders = getNotificationRemindersAsArray(notification);

    const statement = chooseSingular(reminders.length, 'The following task is due', 'The following tasks are due');

    const dueSoon = getIsDueSoon({ notification });

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryTaskReminder"
            figure={<NotificationFigureReminder />}
        >
            <div className="notification-statement">
                {statement}
                {dueSoon ? ' soon' : ''}
                <StandardNotificationBoardTitle {...props} />:
            </div>
            <ReminderEntries reminders={reminders} notification={notification} />
        </BaseNotificationEntry>
    );
};

NotificationEntryTaskReminder.propTypes = {
    notification: PropTypes.object,
    actors: PropTypes.array,
};

export default NotificationEntryTaskReminder;
